import { useEffect, useRef } from 'react';
import { useAuth } from '../components/AuthProvider';
import { NOTIFICATION_TYPE } from '../notifications';
import { notifyMissionInbox } from '../utils/notificationInbox';
import { collectWaitUnlocks } from '../utils/waitUnlockEvents';

/**
 * While the campaign is open, write an inbox item when a time-gated
 * mission becomes available (wait elapsed). Does not fire on first paint.
 */
export function useWaitUnlockNotifications({
  tasks = [],
  lockStates = {},
  campaignId,
  campaignName,
  breadcrumbPath = [],
  enabled = true,
}) {
  const { user, workspaceId } = useAuth();
  const prevWaitingRef = useRef(null);
  const campaignRef = useRef(campaignId);

  useEffect(() => {
    if (campaignRef.current !== campaignId) {
      prevWaitingRef.current = null;
      campaignRef.current = campaignId;
    }
  }, [campaignId]);

  useEffect(() => {
    if (!enabled || !campaignId) return;
    const { nextWaitingIds, unlockedTasks } = collectWaitUnlocks(
      prevWaitingRef.current,
      lockStates,
      tasks
    );
    prevWaitingRef.current = nextWaitingIds;

    for (const task of unlockedTasks) {
      notifyMissionInbox({
        userEmail: user?.email || '',
        workspaceId,
        type: NOTIFICATION_TYPE.MISSION_AVAILABLE,
        task,
        campaignId,
        campaignName,
        breadcrumbPath,
      });
    }
  }, [tasks, lockStates, campaignId, campaignName, breadcrumbPath, enabled, user?.email, workspaceId]);
}
